import { useContext } from 'react';

import { WebThemeContext } from './WebThemeContext';
import type { WebThemeContextProps } from './types';

export const useWebThemeContext = () => useContext(WebThemeContext) as WebThemeContextProps;
